<!--
 * @Author: castic
 * @Date: 2024-12-25 19:10:57
 * @LastEditors: castic
 * @LastEditTime: 2024-12-30 21:32:42
 * @Describe: 
-->
<template>
  <div class="try-login">
    <div class="login-out">
      <div v-if="tryLoinInfoType==1" class="login-wrap">
        <div class="btn" @click="tryLoginClick">免费试玩</div>
        <div class="btn active" @click="toLoginClick">真钱账户</div>
      </div>
      <!-- 游客登录点击某些页面的提示 -->
      <div v-if="tryLoinInfoType==2" class="try-warn">
        <div class="txt d-flex justify-content-center align-items-center">
          <van-icon name="info-o" />
          游客无法访问
        </div>
        <div class="btn change" @click="changeAccType">切换真钱用户</div>
      </div>
    </div>

    <div>
      <div class="pop-close-icon" @click="close"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useUserStore } from '/@/kernel-mn/stores/user';
import { getJSON } from '/@/kernel-mn/utils/storage'
import config from '/@/kernel-mn/config'
import { useEnhancer } from '/@/plugins/enhancer';
import { useGameStore } from '/@/kernel-mn/stores/game';
import { mb_err, mb_loading, mb_t, mb_toast } from "/@/plugins/global.ts";
import { FBQRecordEvent } from "/@/plugins/appsFlyer.ts";
import { remove } from "/@/kernel-mn/utils/storage.ts";
import { removeLastNotice } from "/@/hooks/message.ts";

const { router } = useEnhancer();
const emit = defineEmits(['close'])
const userStore = useUserStore();
const gameStore = useGameStore();

const tryLoinInfoType = computed(()=>{
  const info = userStore.tryLoinInfo
  return info.type
})

const close = ()=>{
  emit('close')
  userStore.setTryLoinInfo({show:false, type:1})
}
const tryLoginClick = ()=>{
  userStore.tryLogin({}).then(res=>{
    // console.log('tryLogin:',res)
    close()
  }).catch(er=>{
    close()
    mb_toast(mb_t('试玩出错'));
    console.log(er)
  })
}
const toLoginClick = ()=>{
  close()
  router.push('/login')
}
const changeAccType = ()=>{
  userStore.logout({app_key: ''}).then((res: any) => {
            if (res && res.response_code === '9999') {
              FBQRecordEvent('logout');
              remove('userInfo');
              remove('game3LoginInfo');
              removeLastNotice(); // 清空公告id
              
    gameStore.clearSportsData(); // 清除体育缓存
    close()
    router.push('/login')
            }
          }).catch(err => {
            mb_err(err.info, 2);
          })
 
}

</script>

<style lang="scss" scope>
.try-login {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // border-radius: px2rem(8);
  .login-out{
    width: 100%;
    padding: px2rem(0) px2rem(10);
    box-sizing: border-box;
  }
  .login-wrap {
    width: 100%;
    padding: px2rem(20) px2rem(0);
    background: #fff;

    border-radius: px2rem(8);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .btn{
      flex: 1;
      margin: 0 px2rem(20);
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      height: px2rem(45);
      font-size: px2rem(16);
       color: rgba(255, 0, 0, 1);
      border-radius: px2rem(6);
      border: 1px solid rgba(255, 0, 0, 1);
      &.active {
        color: #fff;
        background: rgba(240, 75, 15, 1);
      }
      &.change{
        padding: px2rem(5) px2rem(10);
        height: px2rem(35); ;
      }
    }
  .try-warn{
    width: 100%;
    padding: px2rem(20) px2rem(0);
    background: #fff;

    border-radius: px2rem(8);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .txt{
      margin-bottom: px2rem(10);
      font-size: px2rem(16);
      >i {
        margin-right: px2rem(5);
        color: red !important;
        font-size: px2rem(20);
      }
    }
  }

  .pop-close-icon {
    @include WH(px2rem(38), px2rem(38));
    @include bg(var(--lottery-pop-close-icon));
    margin-top: px2rem(20);
  }
}
</style>